import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationMediaGet = {
    path: "/media",
    method: ERouteHttpVerb.GET
};
export { routeLocationMediaGet };
